import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltVideoEditorPlayerApplyButtonLoadingWireframe from './VeltVideoEditorPlayerApplyButtonLoadingWireframe/VeltVideoEditorPlayerApplyButtonLoadingWireframe';
var VeltVideoEditorPlayerApplyButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-apply-button-wireframe", __assign({}, transformedProps), children));
};
VeltVideoEditorPlayerApplyButtonWireframe.Loading = VeltVideoEditorPlayerApplyButtonLoadingWireframe;
export default VeltVideoEditorPlayerApplyButtonWireframe;
